<section>
  <div class="form-register">
    <form [formGroup]="formBreakdown">
      <div class="row p-1">
        <div class="col-lg-3 col-md-6 col-sm-6 col-12">
          <app-custom-input-text [value]="codeNameArticle" [disabled]="true" [labelText]="'Artículo'">
          </app-custom-input-text>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="clientValueList"
            [labelText]="'Precio Lista'"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="unitValue" [labelText]="'Vr.Unit.Base'" [required]="true"
            (onChangeNumber)="updateUnitValue($event)"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="discountRate" [labelText]="'% Descuento'"
            (onChangeNumber)="updateDiscountRate($event)"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="clientValue" [labelText]="'Vr.Cliente'" [required]="true"
            (onChangeNumber)="updateClientValue($event)"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="quantity" [labelText]="'Cantidad'"
            (onChangeNumber)="calculateSubtotalValue()"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="subtotal" [labelText]="'Subtotal'"
            [disabled]="true"></app-custom-input-decimal>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12 col-12 d-flex mt-1">
          <div class="d-flex align-items-end justify-content-end  gap-2 container-buttons bottom-0">
            <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [variant]="undefined"
              (onClick)="send()"></app-custom-button>
            <app-custom-button [label]="'Cancelar'" [severity]="'danger'" (onClick)="clearForm()"></app-custom-button>
          </div>
        </div>
      </div>
    </form>
  </div>